export default __webpack_public_path__ + "static/media/uddipan.d800941d.png";